import {
  IonContent,
  IonFooter,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonSkeletonText,
  IonGrid,
  IonRow,
  IonCol,
  IonSegment,
  IonSegmentButton,
  IonLabel,
} from "@ionic/react";
import React from "react";

const Skeleton__MarketDataOverviewModal: React.FC = () => {
  return (
    <>
      <div style={{ padding: "0 10px" }}>
        <IonSegment>
          <IonSegmentButton value="overview">
            <IonLabel>
              <IonSkeletonText animated={true} style={{ width: "60px" }} />
            </IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="chart">
            <IonLabel>
              <IonSkeletonText animated={true} style={{ width: "60px" }} />
            </IonLabel>
          </IonSegmentButton>
        </IonSegment>
      </div>
      <IonContent>
        <div style={{ margin: "18px 13px" }}>
          <IonSkeletonText
            animated={true}
            style={{ width: "70%", height: "24px", marginBottom: "8px" }}
          />
          <IonSkeletonText
            animated={true}
            style={{ width: "40%", height: "16px", marginBottom: "20px" }}
          />
          <div style={{ marginBottom: "20px" }}>
            <IonSkeletonText
              animated={true}
              style={{ width: "100%", height: "35px", marginBottom: "2px" }}
            />
            {Array.from({ length: 5 }).map((_, i) => (
              <IonSkeletonText
                key={i}
                animated={true}
                style={{
                  width: "100%",
                  height: "25px",
                  marginBottom: "2px",
                  opacity: 0.6,
                }}
              />
            ))}
          </div>
          <div>
            <IonSkeletonText
              animated={true}
              style={{ width: "100%", height: "35px", marginBottom: "2px" }}
            />
            {Array.from({ length: 5 }).map((_, i) => (
              <div
                key={i}
                style={{ display: "flex", gap: "10px", marginBottom: "2px" }}
              >
                <IonSkeletonText
                  animated={true}
                  style={{ width: "50%", height: "30px", opacity: 0.5 }}
                />
                <IonSkeletonText
                  animated={true}
                  style={{ width: "50%", height: "30px", opacity: 0.5 }}
                />
              </div>
            ))}
          </div>
        </div>
      </IonContent>
      <IonFooter
        className="ion-no-padding ion-no-border"
        style={{ marginBottom: "20px" }}
      >
        <IonGrid className="ion-padding">
          <IonRow>
            <IonCol size="6">
              <IonSkeletonText
                animated={true}
                style={{ width: "100%", height: "45px", borderRadius: "4px" }}
              />
            </IonCol>
            <IonCol size="6">
              <IonSkeletonText
                animated={true}
                style={{ width: "100%", height: "45px", borderRadius: "4px" }}
              />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </>
  );
};

export default Skeleton__MarketDataOverviewModal;
